import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

dayjs.extend(relativeTime);
dayjs.extend(utc);

type DateLike = string | number | Date | dayjs.Dayjs;

export function relativeTimeFromNow(date: DateLike) {
  return dayjs(date).from(Date.now());
}

export function isOverdue(date?: DateLike | null) {
  return date != null && daysFromToday(date) < 0;
}

export function formatDateTime(date: DateLike) {
  return dayjs(date).format("MMM D, YYYY [at] h:mm A");
}

export function parseDateString(date: DateLike) {
  return dayjs(date).toDate();
}

export function formatDate(date: DateLike) {
  return dayjs(date).format("MMM D, YYYY");
}

export function formatTimeWithSeconds(date: DateLike) {
  return dayjs(date).format("h:mm:ss A");
}

export function formatDateKey(date: DateLike) {
  return dayjs(date).format("YYYY-MM-DD");
}

/**
 * Returns the difference in days between a date and today.
 * Positive values mean the date is in the future, negative means past.
 */
export function daysFromToday(date: DateLike) {
  return dayjs(date).startOf("day").diff(dayjs().startOf("day"), "day");
}
